'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import PropTypes from 'prop-types';

import { BLOCKS } from '@contentful/rich-text-types';

import Hero from 'app/templates/Recipes/Hero';

import BlockCardGroup from 'components/blocks/BlockCardGroup/BlockCardGroup';
import BlockRelatedPages from 'components/blocks/BlockRelatedPages/BlockRelatedPages';
import BlockSmallMediaWithText from 'components/blocks/BlockSmallMediaWithText/BlockSmallMediaWithText';
import Grid from 'components/ui/Grid';
import RichText from 'components/ui/RichText';
import { getNodeText } from 'components/ui/RichText/defaults';
import Text from 'components/ui/Text';

import BackButton from './BackButton';
import Directions from './Directions';
import Ingredients from './Ingredients';

import styles from './RecipeDetail.module.scss';

const summaryOverrides = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            if (!getNodeText(node.content)) {
                return null;
            }

            return (
                <Text
                    as="h2"
                    className={styles.summary}
                    baseTheme="headingMedium"
                    themes={{ large: 'headingLarge' }}
                    fixWidows
                >
                    {children}
                </Text>
            );
        },
    },
};

const RecipeDetail = ({
    id,
    title,
    creators,
    image,
    images,
    prepTime,
    cookTime,
    serves,
    ingredients,
    summary,
    directions,
    productsBlock,
    relatedRecipes,
    slug,
    recipesConfig,
    attributes,
    relatedPages,
    blocks,
}) => {
    prepTime ??= 0;
    cookTime ??= 0;

    const heroProps = {
        id,
        creators,
        title,
        slug,
        attributes,
        images: images?.length > 0 ? images : [image],
    };

    return (
        <div className={styles.root}>
            <BackButton />
            <Hero
                {...heroProps}
                theme="recipeDetail"
                recipesConfig={recipesConfig}
            />
            <Grid className={styles.directionSection}>
                {summary && (
                    <RichText richText={summary} overrides={summaryOverrides} />
                )}
                {ingredients && (
                    <div className={styles.ingredients}>
                        <Ingredients
                            {...ingredients}
                            prepTime={prepTime}
                            cookTime={cookTime}
                            serves={serves}
                        />
                    </div>
                )}
                {directions && (
                    <div className={styles.directions}>
                        <Directions {...directions} />
                    </div>
                )}
                {productsBlock && (
                    <div className={styles.products}>
                        <Text
                            as="h2"
                            className={styles.productsHeadline}
                            baseTheme="displayXXSmall"
                            themes={{
                                large: 'displayXSmall',
                            }}
                        >
                            Shop this recipe
                        </Text>
                        <BlockCardGroup
                            {...productsBlock}
                            cards={productsBlock?.cardsCollection?.items ?? []}
                            theme="Recipe Products"
                            flushBottom
                            flushTop
                        />
                    </div>
                )}
            </Grid>
            <div className={styles.blocks}>
                {creators?.map((creator, i) => {
                    if (!creator.image) {
                        return;
                    }
                    return (
                        <BlockSmallMediaWithText
                            key={`creator${i}`}
                            eyebrow="Meet the chef"
                            headline={creator.name}
                            body={creator.description}
                            cta={creator.cta}
                            theme="Portrait Image"
                            image={creator.image}
                            mediaPosition={i % 2 === 0 ? 'Left' : 'Right'}
                        />
                    );
                })}
                {blocks}
                {relatedRecipes?.length > 0 && (
                    <BlockCardGroup
                        cards={relatedRecipes ?? []}
                        theme="Recipes"
                        headline="More Great Recipes"
                        backgroundColor="white"
                        flushBottom={!!relatedPages}
                    />
                )}
                {relatedPages && (
                    <BlockRelatedPages
                        {...relatedPages}
                        links={relatedPages.linksCollection.items}
                    />
                )}
            </div>
        </div>
    );
};

RecipeDetail.propTypes = {
    attributes: PropTypes.object,
    category: PropTypes.object,
    cookTime: PropTypes.number,
    creators: PropTypes.array,
    directions: PropTypes.object,
    image: PropTypes.shape({
        description: PropTypes.string,
        url: PropTypes.string.isRequired,
    }).isRequired,
    images: PropTypes.array,
    ingredients: PropTypes.object,
    metaDescription: PropTypes.string,
    prepTime: PropTypes.number,
    productsBlock: PropTypes.object,
    relatedPages: PropTypes.any,
    relatedRecipes: PropTypes.array,
    seoTitle: PropTypes.string,
    serves: PropTypes.string,
    shareDescription: PropTypes.string,
    shareTitle: PropTypes.string,
    recipesConfig: PropTypes.object.isRequired,
    slug: PropTypes.string,
    summary: PropTypes.object,
    title: PropTypes.string.isRequired,
};

export default RecipeDetail;
